export default __webpack_public_path__ + "static/media/alcy.0da396f5.svg";